export const ACCOUNT = "ACCOUNT";
export const COMPANIES = "COMPANIES";
export const SINGLECOMPANY = "SINGLECOMPANY";
export const SUBSCRIPTIONS = "SUBSCRIPTIONS";
export const CURRENT_SUBSCRIPTIONS = "CURRENT_SUBSCRIPTIONS";
export const CREATE_COMPANAY = "CREATE_COMPANAY";
export const DISPUTE = "DISPUTE";
export const PRODUCTS = "PRODUCTS";
export const ORDERS = "ORDERS";
export const SERVICES = "SERVICES";
export const SELLERS = "SELLERS";
export const POINTS_MANAGEMENT = "POINTS_MANAGEMENT";
export const SELLER = "SELLER";
export const PROMOTIONS = "PROMOTIONS";
export const USER_MANAGEMENT = "USER_MANAGEMENT";
export const INVOICE = "INVOICE";
export const NOTIFICATION = "NOTIFICATION";
export const EMPLOYEE = "EMPLOYEE";
export const EMPLOYEE_GROUP = "EMPLOYEE_GROUP";
export const ACCESS_LEVEL = "ACCESS_LEVEL";
export const MANAGE_BUYER = "MANAGE_BUYER";
export const LIVE_SESSION = "LIVE_SESSION";
export const CATEGORY = "CATEGORY";
export const THIRD_PARTY_BUSINESSES = "THIRD_PARTY_BUSINESSES";
export const MANAGED_CLIENTS = "MANAGED_CLIENTS";
export const CLIENTS = "CLIENTS";
export const CLIENT_ONBOARDING = "CLIENT_ONBOARDING";
